import { isPointGeometry, PointGeometry } from "./PointGeometry";

export interface POI {     
    poiId : number;
    poiShortName : string;
    poiName : string;
    poiType : string;
    geometry : PointGeometry;    
}

export function isPOI(object: any) : object is POI {	
    return 'poiId' in object && 
        'poiShortName' in object &&
		'poiName' in object && 
        'poiType' in object &&
		'geometry' in object; // && isPointGeometry(object["geometry"]);
}
